import { getReq } from '../utils/request'
import { ListResponse } from '../types/api'
import { ContainerType } from '../types/data'

export default {
	loadContainerTypes: (municipalityID: string | number, filters: object): ListResponse<{ containerTypes: ContainerType[] }> => getReq(`/api/v0/municipalities/${municipalityID}/container-types`, filters)
}
